import React from "react";
import { Button } from "src/business-types/grocery/components/Button";
import PopupModules from "src/features/auth/components/PopupModules";
import { CategoryV2 } from "src/shared/types";

type Props = {
    list: CategoryV2[] | null;
    onClose: () => void;
    onConfirm: () => void;
};

const DeleteConfirmModal: React.FC<Props> = ({ list, onClose, onConfirm }) => (
    <PopupModules isOpen={!!list} onClose={onClose} title="Confirm Deletion">
        <div className="p-4 flex flex-col gap-4">
            <div className="text-center">
                <p className="text-lg font-semibold text-gray-800 mb-2">Are you sure?</p>
                <p className="text-sm text-gray-600">
                    The following categories will be <span className="font-medium text-red-600">DELETED</span>. This action cannot be undone.
                </p>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg max-h-48 overflow-y-auto p-3">
                {list?.length === 0 && <p className="text-sm text-gray-400 text-center italic">No categories selected</p>}
                {list?.map((cat, i) => (
                    <div key={cat._id.$oid} className="flex flex-col py-1 px-2 rounded hover:bg-gray-100">
                        <div className="flex items-center gap-2">
                            <span className="text-gray-500 text-sm w-6 text-right">{i + 1}.</span>
                            <span className="text-gray-800 text-sm font-medium">{cat.name}</span>
                        </div>
                        {cat.secondName && <span className="text-xs text-gray-500 ml-8">{cat.secondName}</span>}
                    </div>
                ))}
            </div>
            <p className="bg-gray-200 text-red-500 p-2"><b>Note:</b> Products in this category will also be deleted.</p>
            <div className="flex justify-center gap-4 mt-2">
                <Button label="Cancel" variant="ThemeCancel" className="min-w-[100px] border" onClick={onClose} />
                <Button label="Delete" variant="danger" className="min-w-[100px]" onClick={onConfirm} />
            </div>
        </div>
    </PopupModules>
);

export default DeleteConfirmModal;